import ApiError from "@/api/ApiError";

// TODO: Выключили кэширование

export const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (error instanceof ApiError && error.status === 401) {
    return false;
  }

  return failureCount < 3;
};

export const defaultQueryOptions = {
  staleTime: 0,
  gcTime: 0,
  retry: shouldRetryQuery,
};
